var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5V7.5C0 6.8125 0.196 6.22375 0.588 5.73375C0.979333 5.24458 1.45 5 2 5H5V2.5C5 1.8125 5.196 1.22417 5.588 0.735C5.97933 0.245 6.45 0 7 0H13C13.55 0 14.021 0.245 14.413 0.735C14.8043 1.22417 15 1.8125 15 2.5V5H18C18.55 5 19.021 5.24458 19.413 5.73375C19.8043 6.22375 20 6.8125 20 7.5V17.5C20 18.1875 19.8043 18.7763 19.413 19.2663C19.021 19.7554 18.55 20 18 20H2C1.45 20 0.979333 19.7554 0.588 19.2663C0.196 18.7763 0 18.1875 0 17.5ZM2 17.5H18V13.75H16C16 14.1042 15.904 14.4008 15.712 14.64C15.5207 14.88 15.2833 15 15 15C14.7167 15 14.4793 14.88 14.288 14.64C14.096 14.4008 14 14.1042 14 13.75H6C6 14.1042 5.90433 14.4008 5.713 14.64C5.521 14.88 5.28333 15 5 15C4.71667 15 4.479 14.88 4.287 14.64C4.09567 14.4008 4 14.1042 4 13.75H2V17.5ZM2 7.5V11.25H4C4 10.8958 4.09567 10.5987 4.287 10.3587C4.479 10.1196 4.71667 10 5 10C5.28333 10 5.521 10.1196 5.713 10.3587C5.90433 10.5987 6 10.8958 6 11.25H14C14 10.8958 14.096 10.5987 14.288 10.3587C14.4793 10.1196 14.7167 10 15 10C15.2833 10 15.5207 10.1196 15.712 10.3587C15.904 10.5987 16 10.8958 16 11.25H18V7.5H2ZM7 5H13V2.5H7V5Z",
    fill: "#007D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceImg);
export default __webpack_public_path__ + "static/media/serviceImg.aa93c8a92fedaf89cc404ae087860139.svg";
export { ForwardRef as ReactComponent };